/** 回放模块主色：所有紫色统一用这一个，改色只改这里。与系统主题 colorPrimary 一致。 */
export const REPLAY_PRIMARY = '#722ed1';
